import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Update, GetById } from "adminApi/SupplierListApi/SupplierList";
import fields from "../json/SupplierFields.json";
import { validateForm } from "utils/validation";
import { SupplierValidationRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import EditSupplierForm from "./Componates/EditSupplierForm";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";

const EditSupplier = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { formdata } = fields;

  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  const { values, errors, handleChange, setErrors, setValues } = useFormChange(
    initialValues,
    SupplierValidationRules
  );

  // Pre-fill form with existing record
  const { loading: loadingFetch } = useFetchFormDataById(id, formdata, GetById, setValues);

  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      const formData = new FormData();
      Object.entries(formValues).forEach(([key, val]) => formData.append(key, val ?? ""));
      return await Update({ id, data: formData });
    },
    (vals) => {
      const err = validateForm(vals, SupplierValidationRules);
      setErrors(err);
      return err;
    },
    () => navigate(-1),
    "Supplier updated successfully."
  );

  return (
    <>
      {(loadingFetch || loadingSubmit) && <Spinner isSpinner />}
      <EditSupplierForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        title="Update"
      />
    </>
  );
};

export default EditSupplier;
